module.exports = __webpack_public_path__ + "img/text1.c5d07f22.svg";